import React from "react";
import Pages404 from "../../pages/Utility/pages-404";
import config from "../../config";

/**
 * Environment-based route guard
 * Blocks specific route patterns based on the hosting URL
 */
const EnvironmentRouteGuard = ({ children }) => {
  const hostname = window.location.hostname;
  const currentPath = window.location.pathname;

  // Block restaurant and admin routes on customer URL
  if (hostname === config.portal.customerUrl) {
    if (
      (currentPath.startsWith("/restaurant") &&
        currentPath !== "/restaurants") ||
      currentPath.startsWith("/admin")
    ) {
      return <Pages404 />;
    }
  }

  // Block customer-specific routes on admin URL
  if (hostname === config.portal.adminUrl) {
    if (
      currentPath === "/email-verify" ||
      currentPath === "/register" ||
      currentPath === "/forgot-password"
    ) {
      return <Pages404 />;
    }
  }

  // Allow all other routes
  return <>{children}</>;
};

export default EnvironmentRouteGuard;
